export default "__VITE_ASSET__BbxtIZMO__"